export default __webpack_public_path__ + "static/media/dallas.83173340.png";